export const CHECK_ELIGIBILITY = "https://instacred.me/campaign-user-activation?utm_source=Flexmoney";
export const MERCHANT_COUNT = "2 Lakh ";
export const LENDER_COUNT = 7;
export const CREDIT_LINE_COUNT = 45;
export const CITY_COUNT = 100;
export const FLEXMONEY_COMPANY_ADDRESS = "B-404\\405, Rustomjee Central Park, Andheri Kurla Road, Andheri East, Mumbai-400059";